import React from 'react'
import { match } from 'ts-pattern'

import MusicItemLoading from './_components/MusicItemLoading'
import MusicItemSuccess from './_components/MusicItemSuccess'
import MusicItemError from './_components/MusicItemError'

import type { MusicOptionActions } from '../MusicOptions/_hooks/menu-options'
import type {
  MusicItemErrorProps,
  MusicMetadataError,
} from './_components/MusicItemError'
import type {
  MusicItemSuccessProps,
  MusicMetadataSuccess,
} from './_components/MusicItemSuccess'
import type {
  MusicMetadataInit,
  MusicMetadataProcessing,
} from './_components/MusicItemLoading'

export type MusicMetadata =
  | MusicMetadataInit
  | MusicMetadataProcessing
  | MusicMetadataSuccess
  | MusicMetadataError

export interface InternalMusicItemProps
  extends Omit<MusicItemSuccessProps, 'data'>,
    Pick<MusicItemErrorProps, 'onRetry' | 'onDeleted'>,
    MusicOptionActions {
  data: MusicMetadata
  onlyExpand?: boolean
}

const InternalMusicItem: React.FC<InternalMusicItemProps> = (props) => {
  const {
    data,
    playStatus,
    onAudioPlay,
    onRetry,
    onDeleted,
    showTypes,
    onlyExpand,
    onSelect,
    musicOptionsProps,
  } = props

  return match(data)
    .with({ status: 'success' }, (data) => {
      return (
        <MusicItemSuccess
          data={data}
          playStatus={playStatus}
          onAudioPlay={onAudioPlay}
          onDeleted={onDeleted}
          showTypes={showTypes}
          onlyExpand={onlyExpand}
          onSelect={onSelect}
          musicOptionsProps={musicOptionsProps}
        />
      )
    })
    .with({ status: 'error' }, (data) => {
      return (
        <MusicItemError data={data} onRetry={onRetry} onDeleted={onDeleted} />
      )
    })
    .otherwise((data) => {
      return <MusicItemLoading data={data} />
    })
}

export default InternalMusicItem
